import request from "../utils/request";

export const startMatch = (data) => {
  return request({
    url: "/game/core/match/start",
    method: "post",
    data,
  });
};

export const settleMatch = (data) => {
  return request({
    url: "/game/core/match/settle",
    method: "post",
    data,
  });
};

export const getWallet = (params) => {
  return request({
    url: "/game/core/wallet",
    method: "get",
    params,
  });
};

export const getWalletFlows = () => {
  return request({
    url: "/game/core/wallet/flows",
    method: "get",
  });
};

export const getLeaderboard = (gameId) => {
  return request({
    url: `/game/core/leaderboard/${gameId}`,
    method: "get",
  });
};
